var scope_0 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b2dd3e1ad4fceef6888362c450519dc.js').default;
var scope_1 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c7ee8291bc94a13e44ebab0b885c412.js').default;
var scope_2 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5b874dc5fe25a8bb571d5423211bba5c.js').default;
var scope_3 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/652fb965204eb7f3a8817ca4f1efceec.js').default;
var scope_4 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bc630d472957c0cea622bd23225ae6ee.js').default;
var scope_5 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/be9ccfc8fc8d2defe70a672913cdc355.js').default;
var scope_6 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c4964074130151de75bed14606dcfb0a.js').default;
var scope_7 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dbe9ad7cf2535824267263f02ebfcb0f.js').default;
var scope_8 = require('/home/ubuntu/builds/homepage/frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f35d5560a3ee22c336a7ec938f6447fa.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    